<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit staff grade details" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update Staff Grade</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <a-form-item label="Name">
            <a-input
              placeholder="Name"
              v-decorator="['name', {rules: [{ required: true, message: 'Please input a section name!' }]}]"
            />
          </a-form-item>
          <a-form-item label="Description">
            <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'EditStaffGrade',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      staffGradeId: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openStaffGradeEditModal', this.showModal)
  },
  methods: {
    showModal: function(staffGradeId) {
      this.staffGradeId = staffGradeId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/staff_grade/' + staffGradeId).then(({ data }) => {
        const editData = { 'name': data.data.name, 'description': data.data.description }
        this.form.setFieldsValue(editData)
        this.spinning = false
        this.loading = false
      })
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              this.$http
                .patch('/api/staff_grade/' + this.staffGradeId, {
                  name: values.name,
                  description: values.description,
                })
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'Staff grade details edited successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
